import { Input } from 'antd';
import styled from 'styled-components';
import { ProductiveHeading03 } from 'components/styles';

const { TextArea: AntdTextArea } = Input;

export const Wrapper = styled.div<{ isTemplate: boolean }>`
  padding-bottom: var(--layout-01);
  padding-top: ${(props) => props.isTemplate && 'var(--layout-03)'};

  .ck .ck-presence-list__counter,
  .ck.ck-presence-list__marker {
    display: none;
  }

  .ck .ck-presence-list__list-item:first-child {
    margin-left: 0;
  }
`;

interface TitleWrapperProps {
  maxWidth: boolean;
  isResponsive?: boolean;
  isVersionEditorHeader?: boolean;
}

export const TitleWrapper = styled.div<TitleWrapperProps>`
  animation-name: fadeinup;
  opacity: 0;
  animation-duration: 0.5s;
  animation-fill-mode: both;
  animation-name: fadeinup;
  margin: 0 auto var(--spacing-06) auto;
  max-width: ${(p) => (p.maxWidth ? '96%' : '928px')};
  padding: ${(p) =>
    p.isResponsive
      ? '0'
      : p.maxWidth
      ? '0 var(--spacing-09)'
      : '0 var(--spacing-11)'};
  padding-left: ${(p) => p.isVersionEditorHeader && '48px'};
`;

export const TextArea = styled(AntdTextArea)`
  ${ProductiveHeading03};
  background: none;
  border: none;
  resize: none;
  width: 100%;
  min-height: var(--heading-3-line-height);
  &,
  &:focus {
    outline: none;
    box-shadow: none;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SpaceNameStyle = styled.div`
  opacity: 0.5;
  font-size: var(--font-size-base);
`;

export const DocumentHeaderWrapper = styled(TitleWrapper)<TitleWrapperProps>`
  margin-bottom: var(--spacing-02);
`;
